module.exports = __webpack_public_path__ + "img/left-frame.03a9e2c8.svg";